
export default {
  name: "TimeLine",
  data() {
    return {
      aboutItems: [],
    };
  },
};
